import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { isEmpty } from 'util/checks'

import { ConsultaSeguimentoPergunta10Model } from './model-consultaSeguimentoPergunta10'
import {
  hasPergunta10ExemplosFalhouAnySim,
  hasPergunta10ExemplosPassouAnySim,
  isPergunta10ExemplosAllFilled,
  isPergunta10ExemplosAllNao,
} from './utils-consultaSeguimentoPergunta10'

export const PERGUNTA_10_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta10Model> = {
  PERGUNTA_10_HEADER: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: 'PERGUNTA_10_EXEMPLOS',
      },
    ],
  },
  PERGUNTA_10_EXEMPLOS: {
    scrollConditions: [
      {
        if: (value) => isPergunta10ExemplosAllNao(value),
        scrollTo: 'BOTTOM',
      },
      {
        if: (value) =>
          isPergunta10ExemplosAllFilled(value) &&
          hasPergunta10ExemplosPassouAnySim(value) &&
          !hasPergunta10ExemplosFalhouAnySim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) =>
          isPergunta10ExemplosAllFilled(value) &&
          !hasPergunta10ExemplosPassouAnySim(value) &&
          hasPergunta10ExemplosFalhouAnySim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) =>
          isPergunta10ExemplosAllFilled(value) &&
          hasPergunta10ExemplosPassouAnySim(value) &&
          hasPergunta10ExemplosFalhouAnySim(value),
        scrollTo: 'PERGUNTA_10_FREQUENCIA',
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_10_HEADER',
  },
  PERGUNTA_10_FREQUENCIA: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_10_EXEMPLOS',
  },
}
